import { useEffect, useState } from "react";
import { baseUrl, baseUrlServices } from "../shared/";

export const useRequestGet = ( serviceName, refresh = false ) => {
    
    const [data, setData] = useState({
        isLoading: false,
        isError: false,
        data: null
    });

    useEffect(() => {

        const headers = new Headers();
        headers.append('Authorization', `Bearer ${JSON.parse(localStorage.getItem('user_store_ecommerce'))}`);
    
        setData({
            isLoading: true,
            isError: false,
            data: null
        });

        fetch( baseUrlServices.concat(serviceName), {headers} )
            .then( response => response.text() )
            .then( data => {
                setData({
                    isLoading: false,
                    error: false,
                    data: data
                });
            })
            .catch( error => {
                console.log(error);
            })

    },[serviceName, refresh]);
    

    return data
}
